angular.module('callX').service('AudioFileService', ['$http',
  function ($http){

     var getAudioFile = function(uuid,callbacks){
      $http.get("/wapi/callHistory/signedUrl/"+uuid)
          .success(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          })
          .error(function (data, status) {
            if(callbacks !== undefined) { callbacks.success(data, status); }
          });
    };
    

    var requestTranscription = function(callUuids, callbacks) {
      var url = '/v1/api/transcriptions/transcribe';
      
      $http.post(url, callUuids)
        .success(function(data, status) {
          if(callbacks !== undefined) { callbacks.success(data, status); }
        })
        .error(function(data, status) {
          if(callbacks !== undefined) { callbacks.failure(data, status); }
        });
    };
    
    var getCallAISummary = function(callUuid, callbacks) {
      var url = '/v1/call/' + callUuid + '/summary';
      
      $http.get(url)
        .success(function(data, status) {
          if(callbacks !== undefined) { callbacks.success(data, status); }
        })
        .error(function(data, status) {
          if(callbacks !== undefined) { callbacks.failure(data, status); }
        });
    };

    var getCall = function(callUuid, callbacks) {
      var url = '/v1/call/' + callUuid;
      
      $http.get(url)
        .success(function(data, status) {
          if(callbacks !== undefined) { callbacks.success(data, status); }
        })
        .error(function(data, status) {
          if(callbacks !== undefined) { callbacks.failure(data, status); }
        });
    };

    return {
      getAudioFile:function(uuid, callbacks){
        getAudioFile(uuid, callbacks);
      },
      requestTranscription: function(callUuids, callbacks) {
        requestTranscription(callUuids, callbacks);
      },
      getCallAISummary: function(callUuid, callbacks) {
        getCallAISummary(callUuid, callbacks);
      },
      getCall: function(callUuid, callbacks) {
        getCall(callUuid, callbacks);
      },
    };
  }]);